import AboutHero from './components/AboutHero';
import AboutMission from './components/AboutMission';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const seoData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://www.911baoliao.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '关于我们',
          },
        ],
      },
      {
        '@type': 'Organization',
        name: '911爆料网',
        url: 'https://www.911baoliao.com/',
        description:
          '911爆料网是国内领先的娱乐资讯与爆料追踪平台，专注于网红黑料、明星塌房、每日吃瓜资讯的实时追踪与深度报道。',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'tips@911baoliao.com',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 911爆料网',
        description: '了解911爆料网品牌故事、使命愿景、用户口碑和联系方式。',
        url: 'https://www.911baoliao.com/about',
        isPartOf: {
          '@type': 'WebSite',
          name: '911爆料网',
          url: 'https://www.911baoliao.com/',
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '911爆料网是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '911爆料网成立于2020年，是国内领先的娱乐资讯与爆料追踪平台，专注于网红黑料、明星塌房、每日吃瓜资讯的实时追踪与深度报道。',
            },
          },
          {
            '@type': 'Question',
            name: '如何向911爆料网投稿？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过发送邮件至tips@911baoliao.com，或通过网站联系表单提交爆料线索，我们的编辑团队会第一时间审核处理。',
            },
          },
          {
            '@type': 'Question',
            name: '911爆料网的内容更新频率是怎样的？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '911爆料网每天7×24小时不间断追踪全网热点，每日更新数十条最新爆料内容，确保您不错过任何一个大瓜。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <title>关于我们 - 911爆料网 | 品牌介绍、口碑与联系方式</title>
      <meta
        name="description"
        content="了解911爆料网品牌故事、使命愿景、平台数据与用户口碑。911爆料网专注网红黑料、明星塌房、每日吃瓜爆料追踪，打造最有态度的娱乐爆料平台。商务合作邮箱：tips@911baoliao.com。"
      />
      <meta name="keywords" content="911爆料网,关于我们,品牌介绍,联系方式,爆料平台,吃瓜爆料" />
      <link rel="canonical" href="https://www.911baoliao.com/about" />
      <meta property="og:title" content="关于我们 - 911爆料网 | 品牌介绍、口碑与联系方式" />
      <meta property="og:description" content="了解911爆料网品牌故事、使命愿景、平台数据与用户口碑。911爆料网是最有态度的娱乐爆料平台。" />
      <meta property="og:url" content="https://www.911baoliao.com/about" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="关于我们 - 911爆料网" />
      <meta name="twitter:description" content="了解911爆料网品牌故事与联系方式。" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData) }} />

      <main>
        <AboutHero />
        <AboutMission />
        <TestimonialsSection />
        <ContactSection />
      </main>
    </>
  );
}